import { Box, Form } from '@domain-group/suit-theme'

import type { FilterModel } from '@modals/BrowseCampaignComparablesModal/utils/filterModel'
import type { UseBrowseCampaignComparablesModalPayload } from
  '@modals/BrowseCampaignComparablesModal/hooks/useBrowseCampaignComparablesModal'

interface FilterProps {
  browseComparableType: UseBrowseCampaignComparablesModalPayload['browseComparableType'],
  changeFilter: UseBrowseCampaignComparablesModalPayload['callbacks']['changeFilter'],
  filter: FilterModel,
}

const Filter = (props: FilterProps) => {
  const { browseComparableType, changeFilter, filter } = props

  const {
    comparison,
    id,
    selectValues,
    title,
    type,
    value,
    valueMax,
  } = filter

  const hideSoldDateFilter = ['agency_current', 'market_current', 'market_rental'].includes(browseComparableType)

  // currently listed properties and rentals don't have a sold date
  if (id === 'sold_date' && hideSoldDateFilter) return null

  return (
    <Form.Field label={title} marginTop="large">
      {type === 'selector' && (
        <select onChange={e => changeFilter({ key: id, name: 'value', value: e.target.value })} value={value}>
          {/*
           // @ts-expect-error TS18048 */}
          {selectValues.map(option => (
            <option key={option.value} value={option.value}>
              {option.title}
            </option>
          ))}
        </select>
      )}

      {type === 'input' && (
        <input
          onChange={e => changeFilter({ key: id, name: 'value', value: e.target.value })}
          type="number"
          value={value}
        />
      )}

      {type === 'date' && (
        <Form.Row>
          <input
            onChange={e => changeFilter({ key: id, name: 'value', value: e.target.value })}
            type="date"
            value={value}
          />

          <input
            onChange={e => changeFilter({ key: id, name: 'valueMax', value: e.target.value })}
            type="date"
            value={valueMax}
          />
        </Form.Row>
      )}

      {type === 'comparison' && (
        <Form.Row>
          <Box>
            <select
              onChange={e => changeFilter({ key: id, name: 'comparison', value: e.target.value })}
              style={{ flex: 1 }}
              value={comparison}
            >
              <option value="gt">is greater than</option>
              <option value="lt">is less than</option>
              <option value="eq">is equal to</option>
              <option value="bt">is between</option>
            </select>
          </Box>

          <Box>
            <input
              onChange={e => changeFilter({ key: id, name: 'value', value: e.target.value })}
              type="number"
              value={value}
            />

            {comparison === 'bt' && (
            <input
              onChange={e => changeFilter({ key: id, name: 'valueMax', value: e.target.value })}
              type="number"
              value={valueMax}
              style={{ marginLeft: 8 }}
            />
            )}
          </Box>
        </Form.Row>
      )}
    </Form.Field>
  )
}

export default Filter
